import { render } from "./IVRSessionsView.vue?vue&type=template&id=cbb097b8&scoped=true"
import script from "./IVRSessionsView.vue?vue&type=script&lang=js"
export * from "./IVRSessionsView.vue?vue&type=script&lang=js"

import "./IVRSessionsView.vue?vue&type=style&index=0&id=cbb097b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb097b8"]])

export default __exports__